import { render, staticRenderFns } from "./IdiomDetailsS.vue?vue&type=template&id=515a21be&scoped=true&"
import script from "./IdiomDetailsS.vue?vue&type=script&lang=js&"
export * from "./IdiomDetailsS.vue?vue&type=script&lang=js&"
import style0 from "./IdiomDetailsS.vue?vue&type=style&index=0&id=515a21be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515a21be",
  null
  
)

export default component.exports